<template>
  <div style="width: 100%; height: 100%">
    <div class="codemirror">
      <codemirror v-model="code" :options="cmOption" class="code-mirror">
      </codemirror>
      <div class="bottom_button">
        <a-button type="primary" style="margin-right: 20px" @click="hideSelf()"
          >确认</a-button
        >
        <a-button type="danger" @click="hideSelf()">取消</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/utils/Bus";
import { codemirror } from "vue-codemirror";
export default {
  name: "CodeDrawer",
  components: {
    codemirror,
  },
  data() {
    return {
      code: "",
      cmOption: {
        tabSize: 2, // tab
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: {
          // 模式, 可查看 codemirror/mode 中的所有模式
          name: "javascript",
          json: true,
        },
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false,
        },
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "base16-light", // 主题
        extraKeys: { Ctrl: "autocomplete" }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
      },
    };
  },
  methods: {
    hideSelf() {
      bus.$emit("code-drawer", false);
    },
  },
};
</script>
<style scoped>
@import url("./index.css");
</style>